<template>
    <v-dialog v-model="shows" fullscreen :disabled="!src" content-class="black">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
            <v-avatar v-if="!hideActivator" v-bind="{ ...attrs, ...attrs_avatar }" v-on="on" :style="!src ? 'cursor:initial' : ''" rounded="0" @click.prevent.stop>
                <template v-if="isPDF">
                    <embed v-bind="{ src }" type="application/pdf" class="fill-height" style="pointer-events: none" />
                </template>
                <template v-else>
                    <v-img :src="src" alt="" v-bind="$attrs">
                        <template v-slot:placeholder>
                            <v-overlay absolute opacity="0.1">
                                <v-icon>mdi-image-broken-variant</v-icon>
                            </v-overlay>
                        </template>
                    </v-img>
                </template>
            </v-avatar>
        </template>
        <template v-if="src">
            <v-card dark flat tile class="fill-height d-flex flex-column">
                <v-card-title>
                    미리보기
                    <v-spacer />
                    <v-btn icon tile class="transparent ma-n1" @click="shows = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text style="flex: 1">
                    <template v-if="isPDF">
                        <embed v-bind="{ src }" type="application/pdf" width="100%" height="100%" />
                    </template>
                    <template v-else>
                        <v-layout justify-center align-center fill-height>
                            <v-img :src="src" contain max-width="85vh" max-height="85vh" />
                        </v-layout>
                    </template>
                </v-card-text>
            </v-card>
        </template>
    </v-dialog>
</template>

<script>
export default {
    props: {
        src: { type: String, default: undefined },
        attrs_avatar: { type: Object, default: () => ({}) },
        hideActivator: { type: Boolean, default: false },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        isPDF() {
            return this.src?.endsWith?.(".pdf") || this.$attrs?.isPDF;
        },
    },
};
</script>

<style></style>
